import * as React from 'react';
import { Panel } from '@ixicare/ui';
import siteWrapper, { SiteWrapperProps } from '../utils/siteWrapper';
import SitePlaneBeaconMapContainer from '../containers/SitePlaneMap';

interface SitePlaneUpdatePageProps extends SiteWrapperProps {
  planeId: number;
}

const SitePlaneUpdatePage: React.FC<SitePlaneUpdatePageProps> = ({ site, planeId }) => {
  return (
    <Panel>
      <SitePlaneBeaconMapContainer site={site} initialPlaneId={planeId} />
    </Panel>
  );
};

export default siteWrapper(SitePlaneUpdatePage, ({ query }) => {
  const { planeId } = query;
  return {
    planeId: parseInt(planeId, 10),
  };
});
